import {CSSProperties, FC} from 'react';


export interface IIconWindshieldHeatBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconWindshieldHeatBmw: FC<IIconWindshieldHeatBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M4.305 6.413a21.998 21.998 0 0 1 15.39 0l.305.114v.854l-1.981 7.627h-2.193c.323.474.494 1.007.494 1.563 0 .918-.467 1.773-1.313 2.406l-.562-.75c.604-.453.937-1.04.937-1.656 0-.575-.29-1.125-.818-1.563h1.262a3.562 3.562 0 0 0-.82-.844c-.604-.452-.936-1.04-.936-1.656 0-.616.332-1.204.937-1.656l-.562-.75c-.847.633-1.313 1.487-1.313 2.406s.466 1.774 1.313 2.407l.119.093h-1.488c.323.474.494 1.007.494 1.563 0 .918-.467 1.773-1.313 2.406l-.562-.75c.604-.453.937-1.04.937-1.656 0-.575-.29-1.125-.818-1.563h1.262a3.562 3.562 0 0 0-.82-.844c-.604-.452-.936-1.04-.936-1.656 0-.616.332-1.204.937-1.656l-.562-.75c-.847.633-1.313 1.487-1.313 2.406s.466 1.774 1.313 2.407l.119.093h-1.488c.323.474.494 1.007.494 1.563 0 .918-.467 1.773-1.313 2.406l-.562-.75c.604-.453.937-1.04.937-1.656 0-.575-.29-1.125-.818-1.563h1.262a3.562 3.562 0 0 0-.82-.844c-.604-.452-.936-1.04-.936-1.656 0-.616.332-1.204.937-1.656l-.562-.75c-.847.633-1.313 1.487-1.313 2.406s.466 1.774 1.313 2.407l.119.093H5.98L4 7.381v-.854l.305-.114Z" clipRule="evenodd" />
        </svg>
    );
};
